var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.periodesMetOnderbrekingen.length === 0
      ? _c("h3", { key: "h-opdracht-none" }, [_vm._v("Geen afwezigheden")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "periodes" },
      _vm._l(_vm.periodesMetOnderbrekingen, function(
        periodeMetOnderbrekingen,
        index
      ) {
        return _c(
          "div",
          { key: "periode-" + index },
          [
            _c(
              "section-card",
              {
                attrs: {
                  "card-title": _vm.periodeTitle(
                    periodeMetOnderbrekingen.periode
                  ),
                  "smaller-title": "",
                  "card-icon": _vm.periodeIcon(periodeMetOnderbrekingen.periode)
                }
              },
              _vm._l(periodeMetOnderbrekingen.onderbrekingen, function(
                onderbreking,
                index
              ) {
                return _c(
                  "div",
                  {
                    key: "opdracht-wrapper" + index,
                    staticClass: "col-sm-12 justify-content-center"
                  },
                  [
                    _c(
                      "ehr-card",
                      {
                        key: "onderbreking-card" + index,
                        staticClass: "mb-4 list-item"
                      },
                      [
                        _c("onderbreking-card-content", {
                          attrs: { onderbreking: onderbreking }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }